(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

(function($) {
	var SWindow = require("./index");
	$.SWindow = SWindow;
})(window);

},{"./index":2}],2:[function(require,module,exports){
const
	Operation = require("./lib/ops"),
	TimeStats = require("./lib/timestats"),
	SizeStats = require("./lib/sizestats");

module.exports = {
	TimeStats : TimeStats,
	SizeStats : SizeStats,
	Operation : Operation,
	register : Operation.register
};

},{"./lib/ops":4,"./lib/sizestats":6,"./lib/timestats":7}],3:[function(require,module,exports){
module.exports = {
	sum(currval,newitems,olditems,allitems,newstats,oldstats) {
		currval = currval===undefined? {} : currval;
		var ln = newitems.length, lo = olditems.length;
		for(let i=0;i<ln;i++) {
			for(let j in newitems[i].v) {
				currval[j] = currval[j] || 0;
				currval[j] += newitems[i].v[j];
			}
		}
		for(let i=0;i<lo;i++) {
			for(let j in olditems[i].v) {
				currval[j] = currval[j] || 0;
				currval[j] -= olditems[i].v[j];
			}
		}
		return currval;
	},
	freq(currval,newitems,olditems,allitems,newstats,oldstats) {
		var sums = newstats.sum;
		var total = 0, res = {};
		for(let i in sums) total += sums[i];
		for(let i in sums) res[i] = sums[i] / total;
		return res;
	},
	mode(currval,newitems,olditems,allitems,newstats,oldstats) {
		var sums = newstats.sum;
		var map = [];
		for(let i in sums) map.push({k:i,t:sums[i]});
		map.sort((a,b)=>a.t-b.t);
		return (map.pop()||{}).k;
	}
}

},{}],4:[function(require,module,exports){
const
	NOps = require("./nops"),
	COps = require("./cops");

// Default operations
const DEF_OPS = {
	numeric : ["count","sum","max","min","avg","stdev"],
	category : ["sum","freq","mode"]
};

// Stats function type constants
const TYPES = {
	numeric : "numeric",
	category : "category"
};

// Registered operations
const OPS = {
	numeric : {
		"count" : {fn:NOps.count,deps:[]},
		"sum" : {fn:NOps.sum,deps:[]},
		"max" : {fn:NOps.max,deps:[]},
		"min" : {fn:NOps.min,deps:[]},
		"avg" : {fn:NOps.avg,deps:[]},
		"stdev" : {fn:NOps.stdev,deps:["avg"]},
	},
	category : {
		"sum" : {fn:COps.sum,deps:[]},
		"freq" : {fn:COps.freq,deps:["sum"]},
		"mode" : {fn:COps.mode,deps:["sum"]}
	}
};

/**
 * Registers a new operation
 * @param type [TYPES.numeric / TYPES.category]
 * @param name The name of the stat function
 * @param deps Array of dependency names
 * @param fn Stats function to be called, in the form of
 * fn(currval,newitems,olditems,allitems,newstats,oldstats)
 * @param def Use by default.
 */
function register(type,name,deps,fn,def) {
	OPS[type][name] = {fn:fn,deps:deps};
	if(def) DEF_OPS[type].push(name);
}

module.exports = {
	NOps,
	COps,
	RXOps:OPS,
	DEFOps:DEF_OPS,
	Types:TYPES,
	register
}

},{"./cops":3,"./nops":5}],5:[function(require,module,exports){
const OPS = {
	count(currval,newitems,olditems,allitems,newstats,oldstats) {
		var t = 0, len = allitems.length;
		for(var i=0;i<len;i++) t += (allitems[i].l||1);
		return t;
	},
	sum(currval,newitems,olditems,allitems,newstats,oldstats) {
		currval = currval===undefined? 0 : currval;
		var ln = newitems.length, lo = olditems.length;
		for(let i=0;i<ln;i++) currval += newitems[i].v;
		for(let i=0;i<lo;i++) currval -= olditems[i].v;

		return currval;
	},
	max(currval,newitems,olditems,allitems,newstats,oldstats) {
		var max = -Infinity, len = allitems.length;
		for(let i=0;i<len;i++)
			max = Math.max(max,allitems[i].max);
		return max;
	},
	min(currval,newitems,olditems,allitems,newstats,oldstats) {
		var min = Infinity, len = allitems.length;
		for(let i=0;i<len;i++)
			min = Math.min(min,allitems[i].min);
		return min;
	},
	avg(currval,newitems,olditems,allitems,newstats,oldstats) {
		var
			ln = OPS.count(0,0,0,newitems), lo = OPS.count(0,0,0,olditems),
			nvl = OPS.count(0,0,0,allitems), ovl = nvl-ln+lo;

		currval = currval===undefined? 0 : currval;
		currval = currval * ovl;

		for(let i=0;i<newitems.length;i++) currval += newitems[i].v;
		for(let i=0;i<olditems.length;i++) currval -= olditems[i].v;
		currval = currval / nvl;
		return isNaN(currval)? 0 : currval;
	},
	stdev(currval,newitems,olditems,allitems,newstats,oldstats) {
		oldstats.stdev = oldstats.stdev || {avg:1,sqsum:0,sum:0,stdev:0};

		var
			ln = OPS.count(0,0,0,newitems), lo = OPS.count(0,0,0,olditems),
			nvl = OPS.count(0,0,0,allitems), ovl = nvl-ln+lo,
			len = allitems.length,
			oavg = oldstats.avg || 0;

		var oldavg = oldstats.stdev.avg;
		var oldsqsum = oldstats.stdev.sqsum;
		var oldsum = oldstats.stdev.sum;
		var newavg = newstats.avg || 0;
		var newsqsum = oldsqsum;
		var newsum = oldsum;

		for(let i=0;i<olditems.length;i++) {
			let it = olditems[i].v / (olditems[i].l||1);
			newsqsum -= it*it;
			newsum -= it;
		}

		for(let i=0;i<newitems.length;i++) {
			let it = newitems[i].v / (newitems[i].l||1);
			newsqsum += it*it;
			newsum += it;
		}

		var stdev = Math.sqrt((newsqsum - 2*newavg*newsum + len*newavg*newavg) / len);
		return {
			avg : newavg,
			sqsum : newsqsum,
			sum : newsum,
			stdev : stdev
		}
	}
}

module.exports = OPS;

},{}],6:[function(require,module,exports){
const
	Operation = require("./ops"),
	Util = require("./util"),
	Types = Operation.Types,
	RXOps = Operation.RXOps,
	DEFOps = Operation.DEFOps;

// Default options
const DEF_OPTIONS = {
	type : Types.numeric,
	ops : DEFOps.numeric,
	step : 1000
};

/**
 * SizeStats Slide Window
 * @class
 */
class SizeStats {
	/**
	 * @param {numeric} size Number of maximum slots before slide
	 * @param {[type]} options Options
	 */
	constructor(size,options) {
		options = options || DEF_OPTIONS;

		this._options = options;
		this._arr = [];
		this._size = size || 1000;
		this._type = options.type || DEF_OPTIONS.type;
		this._ops = options.ops || DEFOps[this._type];
		this.stats = Util.clone(options.stats||{});

		Util.sortOps(this._ops,this._type);
	}

	clean() {
		this._arr = [];
		this._oldstats = {};
		this.stats = Util.clone(this._options.stats||{});
	}

	get length() {
		return this._arr.length;
	}

	push(vals) {
		vals = vals instanceof Array? vals : [vals];

		return this._type==Types.numeric?
			this._pushNum(vals) :
			this._pushCat(vals);
	}

	_pushNum(vals) {
		var arr = this._arr, old = [];
		var type = this._type;
		var oldstats = Util.clone(this.stats);

		vals = vals.map(v=>{return {v:v,l:1,max:v,min:v};});
		vals.forEach(v=>this._arr.push(v));

		while(this._arr.length>this._size) {
			old.push(this._arr.shift());
		}

		this._ops.forEach(op=>{
			this.stats[op] = RXOps[type][op].fn(this.stats[op],vals,old,arr,this.stats,oldstats);
		});

		return this;
	}

	_pushCat(vals) {
		var arr = this._arr, old = [];
		var type = this._type;
		var oldstats = Util.clone(this.stats);
		var map = {v:{}};

		vals.forEach(v=>{
			map.v[v] = map.v[v] || 0;
			map.v[v]++;
		});
		this._arr.push(map);

		while(this._arr.length>this._size) {
			old.push(this._arr.shift());
		}

		this._ops.forEach(op=>{
			this.stats[op] = RXOps[type][op].fn(this.stats[op],[map],old,arr,this.stats,oldstats);
		});

		return this;
	}

	get window() {
		let type = this._type;
		let win = this._arr.map(slot=>{
			let ops = {};
			this._ops.forEach(op=>{
				ops[op] = RXOps[type][op].fn(undefined,[slot],[],[slot],ops,{});
			});
			return ops;
		});
		return win;
	}	
}

module.exports = SizeStats;

},{"./ops":4,"./util":8}],7:[function(require,module,exports){
const
	Operation = require("./ops"),
	Util = require("./util"),
	Types = Operation.Types,
	RXOps = Operation.RXOps,
	DEFOps = Operation.DEFOps;

// Default options
const DEF_OPTIONS = {
	type : Types.numeric,
	ops : DEFOps.numeric,
	step : 1000
};

const IVAL = 1000;	// Slide window interval
const LIST = [];		// Active window instances

/**
 * Slide time window interval
 */
setInterval(()=>{
	var now = Date.now();

	// For each stat created object
	LIST.filter(sws=>!sws._pause).forEach(sws=>{
		var arr = sws._arr, time = sws._time;
		var type = sws._type;
		var old = [];
		var oldstats = Util.clone(sws.stats);

		// Remove slots whose date has expired
		while(arr.length && now-arr[0].t>time)
			old.push(arr.shift());

		// Execute each stat operation over the remaining slots
		sws._ops.forEach(op=>{
			sws.stats[op] = RXOps[type][op].fn(sws.stats[op],[],old,sws._arr,sws.stats,oldstats);
		});
	});
},IVAL);


/**
 * TimeStats Slide Window
 * @class
 */
class TimeStats {
	static get TS()  {
		return {
			ABSOLUTE : "absolute",
			RELATIVE : "relative"
		}
	}

	/**
	 * @param {numeric} time	Time (ms) of the duration of the window, before slide
	 * @param {object} options	options
	 */
	constructor(time,options) {
		options = options || DEF_OPTIONS;
		this._options = options;
		this._arr = [];
		this._time = time || 10000;
		this._tst = options.timestamp || TimeStats.TS.ABSOLUTE;
		this._type = options.type || DEF_OPTIONS.type;
		this._ops = options.ops || DEFOps[this._type];
		this._step = options.step || DEF_OPTIONS.step;
		this._pause = false;
		this._active = true;
		this._oldstats = {};
		this._mints = Infinity;
		this._maxts = -Infinity;
		this.stats = Util.clone(options.stats||{});

		Util.sortOps(this._ops,this._type);
		if(this._tst==TimeStats.TS.ABSOLUTE)
			LIST.push(this);
	}

	get length() {
		return this._arr.length;
	}

	clean() {
		this._arr = [];
		this._oldstats = {};
		this.stats = Util.clone(this._options.stats||{});
	}

	push(vals) {
		if(!this._active || this._pause) return;

		vals = vals instanceof Array? vals : [vals];

		if(this._tst==TimeStats.TS.ABSOLUTE) {
			return this._type==Types.numeric?
				this._pushNum(vals) :	this._pushCat(vals);
		}
		else {
			return this._type==Types.numeric?
				this._pushNumRel(vals) :	this._pushCatRel(vals);
		}
	}

	pause() {
		this._pause = true;
	}

	resume(shift) {
		var arr = this._arr;
		if(shift && arr.length) {
			var now = Date.now();
			var last = arr[arr.length].t;
			var diff = now - last;
			arr.length.forEach(v=>v.t+=diff);
		}
		this._pause = false;
	}

	destroy() {
		var idx = LIST.indexOf(this);
		if(idx>=0) LIST.splice(idx,1);
		this._active = false;
	}

	_pushNum(vals) {
		let
			now = Date.now(),
			arr = this._arr,
			type = this._type,
			oldstats = Util.clone(this.stats);

		// Map values to stat object
		vals = vals.map(v=>{return {t:now,v:v,l:1,max:v,min:v};});

		// First slot in array
		if(!arr.length) arr.push({t:now,v:0,l:0,max:-Infinity,min:Infinity});

		// Get last slot
		let last = arr[arr.length-1];

		// Value fits in current slot
		if(now-last.t < this._step) {
			// Clone the current slot to make the diff
			last = Util.clone(last);

			// Acumulate on the slot copy
			vals.forEach(v=>{
				last.v+=v.v; last.l+=1;
				last.max = Math.max(last.max,v.v),
				last.min = Math.min(last.min,v.v)
			});

			// Remove the original slot and push the copy
			var oa = [arr.pop()], na = [last];
			arr.push(last);

			// Apply operations
			this._ops.forEach(op=>{
				this.stats[op] = RXOps[type][op].fn(this.stats[op],na,oa,arr,this.stats,oldstats);
			});
		}
		else {
			vals.forEach(v=>{arr.push(v)});
			this._ops.forEach(op=>{
				this.stats[op] = RXOps[type][op].fn(this.stats[op],vals,[],arr,this.stats,oldstats);
			});
		}

		return this;
	}

	_pushNumRel(vals) {
		let
			now = Date.now(),
			arr = this._arr,
			type = this._type,
			oldstats = Util.clone(this.stats);

		vals = vals.map(v=>{return {t:v.t||now,v:v.v,l:1,max:v.v,min:v.v};});

		vals.forEach(v=>{
			// First element
			if(!arr.length) {
				arr.push(v);
				this._mints = v.t;
				this._maxts = v.t;
				return;
			}

			// Ignore values older than current time window
			let tsdist = this._maxts - v.t;
			if(tsdist>this._time) return;

			// Find the closest slot by time difference
			let tss = arr.map((slot,i)=>{
				return {dt:Math.abs(slot.t-v.t),i:i}
			}).sort((a,b)=>{
				return b.dt-a.dt;
			}).pop();
			let slot = arr[tss.i];

			// Value fits in this slot
			if(Math.abs(v.t-slot.t)<this._step) {
				let cloned = Util.clone(slot);

				cloned.v+=v.v; cloned.l+=1;
				cloned.max = Math.max(cloned.max,v.v),
				cloned.min = Math.min(cloned.min,v.v)

				// Remove the original slot and push the copy
				var oa = arr.splice(tss.i,1), na = [cloned];
				arr.push(cloned);

				// Apply operations
				this._ops.forEach(op=>{
					this.stats[op] = RXOps[type][op].fn(this.stats[op],na,oa,arr,this.stats,oldstats);
				});
			}
			// Create a new slot
			else {
				arr.push(v);
				this._ops.forEach(op=>{
					this.stats[op] = RXOps[type][op].fn(this.stats[op],[v],[],arr,this.stats,oldstats);
				});
			}

			// Update window time range
			this._mints = Math.min(v.t,this._mints);
			this._maxts = Math.max(v.t,this._maxts);
			oldstats = Util.clone(this.stats);
		});

		// Sort window
		arr.sort((a,b)=>a.t-b.t);

		// Remove old slots
		let old = [];
		while(Math.abs(this._mints-this._maxts)>this._time) {
			old.push(arr.shift());
			this._mints = arr[0].t;
		}

		// Refresh operations
		if(old.length) {
			this._ops.forEach(op=>{
				this.stats[op] = RXOps[type][op].fn(this.stats[op],[],old,arr,this.stats,oldstats);
			});
		}

		return this;
	}

	_pushCat(vals) {
		var now = Date.now();
		var arr = this._arr;
		var type = this._type;
		var oldstats = Util.clone(this.stats);
		var map = {}

		vals.forEach(v=>{
			map[v] = map[v] || 0;
			map[v]++;
		});

		if(!arr.length) arr.push({t:now,v:{}});
		var last = Util.clone(arr[arr.length-1]);

		if(now-last.t < this._step) {
			for(let i in map) {
				last.v[i] = last.v[i] || 0;
				last.v[i] += map[i];
			}
			var oa = [arr.pop()], na = [last];
			arr.push(last);
			this._ops.forEach(op=>{
				this.stats[op] = RXOps[type][op].fn(this.stats[op],na,oa,arr,this.stats,oldstats);
			});
		}
		else {
			var item = {t:now,v:map};
			arr.push(item);
			this._ops.forEach(op=>{
				this.stats[op] = RXOps[type][op].fn(this.stats[op],[item],[],arr,this.stats,oldstats);
			});
		}

		return this;
	}

	_pushCatRel(vals) {
		let
			arr = this._arr,
			type = this._type,
			oldstats = Util.clone(this.stats);

		vals.forEach(v=>{
			// First element
			if(!arr.length) {
				arr.push({t:v.t,v:{[v.v]:1}});
				this._mints = v.t;
				this._maxts = v.t;
				return;
			}

			// Ignore values older than current time window
			let tsdist = this._maxts - v.t;
			if(tsdist>this._time) return;

			// Find the closest slot by time difference
			let tss = arr.map((slot,i)=>{
				return {dt:Math.abs(slot.t-v.t),i:i}
			}).sort((a,b)=>{
				return b.dt-a.dt;
			}).pop();
			let slot = arr[tss.i];

			// Value fits in this slot
			if(Math.abs(v.t-slot.t)<this._step) {
				let cloned = Util.clone(slot);

				cloned.v[v.v] = cloned.v[v.v] || 0;
				cloned.v[v.v] += 1;

				// Remove the original slot and push the copy
				var oa = arr.splice(tss.i,1), na = [cloned];
				arr.push(cloned);

				// Apply operations
				this._ops.forEach(op=>{
					this.stats[op] = RXOps[type][op].fn(this.stats[op],na,oa,arr,this.stats,oldstats);
				});
			}
			// Create a new slot
			else {
				let newslot = {t:v.t,v:{[v.v]:1}};
				arr.push(newslot);
				this._ops.forEach(op=>{
					this.stats[op] = RXOps[type][op].fn(this.stats[op],newslot,[],arr,this.stats,oldstats);
				});
			}

			// Update window time range
			this._mints = Math.min(v.t,this._mints);
			this._maxts = Math.max(v.t,this._maxts);
			oldstats = Util.clone(this.stats);
		});

		// Sort window
		arr.sort((a,b)=>a.t-b.t);

		// Remove old slots
		let old = [];
		while(Math.abs(this._mints-this._maxts)>this._time) {
			old.push(arr.shift());
			this._mints = arr[0].t;
		}

		// Refresh operations
		if(old.length) {
			this._ops.forEach(op=>{
				this.stats[op] = RXOps[type][op].fn(this.stats[op],[],old,arr,this.stats,oldstats);
			});
		}

		return this;
	}

	get window() {
		let type = this._type;
		let win = this._arr.map(slot=>{
			let ops = {t:slot.t};
			this._ops.forEach(op=>{
				ops[op] = RXOps[type][op].fn(undefined,[slot],[],[slot],ops,{});
			});
			return ops;
		});
		return win;
	}
}

module.exports = TimeStats;

},{"./ops":4,"./util":8}],8:[function(require,module,exports){
const RXOps = require("./ops").RXOps;

/**
 * Simple object clone function
 */
function clone(obj) {
	if(typeof(obj)!="object") {
		return obj;
	}
	else {
		var o = {};
		for(var i in obj) o[i] = clone(obj[i]);
		return o;
	}
}

function depends(a,b,type) {
	var deps = RXOps[type][a].deps;
	if(!deps.length) return false;
	else if(deps.indexOf(b)>=0) return true;
	else {
		return deps.reduce((curr,val)=>curr||depends(val,b,type),false);
	}
}

/**
 * Sorts category operations by its dependencies
 */
function sortOps(ops,type) {
	var map = {}, n = false;

	ops.forEach(op=>map[op] = true);
	do {
		n = false;
		ops.forEach(op=>{
			RXOps[type][op].deps.forEach(dep=>{
				if(!map[dep]) {
					map[dep] = true;
					ops.push(dep);
					n = true;
				};
			});
		});
	}while(n);

	// Stupid sort because Array.sort will not work with dependency sorting
	if(ops.length>1) {
		let tmp = null, it = false;
		do {
			it = false;
			for(let i=0;i<ops.length;i++) {
				for(let j=i;j<ops.length;j++) {
					if(depends(ops[i],ops[j],type)) {
						tmp = ops[i];
						ops[i] = ops[j];
						ops[j] = tmp;
						it = true;
					}
				}
			}
		}while(it);
	}
}

module.exports = {clone,depends,sortOps}

},{"./ops":4}]},{},[1]);
